'use client'
import Loader from 'components/loader';
import style from './style.module.scss';
import { forwardRef } from 'react';
import ValidationHelper from '@/utils/validation.util';

type ButtonDropdownType = {
    color?: "primary" | "secondary" | "danger" | "green";
    disabled?: boolean;
    isLoading?: boolean;
    icon?: any;
    text?: string;
    textElement?: any;
    type?: "reset" | "submit" | "button",
    onClick?: (e: any) => void;
    customClasses?: string;
    id?: string;
    inlineStyle?: any;
    isSelected?: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

const ButtonDropdown = forwardRef<HTMLButtonElement, ButtonDropdownType> (({ color, disabled, isLoading, icon, text, textElement, type = "button", onClick, customClasses, id, inlineStyle, isSelected = false, onKeyDown }: ButtonDropdownType, ref) => {
    return (
        <button
            className={`
                ${style.cBtn} 
                ${isSelected && style.cBtn____isSelected} 
                ${style[`cBtn____${color}`]}
                ${style[`cBtn____${color}`]}
                ${customClasses}
            `} 
            disabled={disabled} 
            type={type}
            id={id || undefined}
            onClick={(e: any) => onClick?.(e)}
            style={inlineStyle}
            title={text}
            onKeyDown={onKeyDown ? (e) => onKeyDown(e) : undefined}
            ref={ref}
        >
            {isLoading ? 
                <Loader /> : (
                <>
                    {icon && icon}
                    {text && ValidationHelper.isPropertyNullOrEmpty(textElement) && (<span className={`${style.cBtn__text} ${'u-ellipsis'}`}>{text}</span>)}
                    {!ValidationHelper.isPropertyNullOrEmpty(textElement) && textElement}
                </>
            )}
        </button>
    )
});

ButtonDropdown.displayName = "ButtonDropdown";

export default ButtonDropdown
